<script setup lang="ts">
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Pagination, Slide } from 'vue3-carousel';
import ArticleCard from '~/components/blog/ArticleCard.vue';
import SkeletonArticleCard from '~/components/blog/SkeletonArticleCard.vue';

const blogStore = useBlogStore();

const breakpoints = {
  768: {
    itemsToShow: 2,
    itemsToScroll: 1,
  },
  992: {
    itemsToShow: 3,
    itemsToScroll: 1,
  },
  1200: {
    itemsToShow: 4,
    itemsToScroll: 2,
  },
};
</script>

<template>
  <ClientOnly>
    <div class="container">
      <div class="row">
        <div class="col">
          <Carousel
            snap-align="start"
            :items-to-show="1"
            :items-to-scroll="1"
            :wrap-around="false"
            :mouse-drag="false"
            :breakpoints="breakpoints"
          >
            <template v-if="blogStore.loadingHomepagePosts || blogStore.homepagePosts.length === 0">
              <Slide v-for="slide in 4" :key="slide">
                <SkeletonArticleCard />
              </Slide>
            </template>

            <template v-else>
              <Slide v-for="post in blogStore.homepagePosts" :key="post.id">
                <ArticleCard :post="post" />
              </Slide>
            </template>

            <template #addons>
              <Pagination />
            </template>
          </Carousel>
        </div>
      </div>

      <div class="row">
        <div class="col col--show-more">
          <Button
            as="a"
            class="show-all-instruments"
            target="_blank"
            rel="nofollow"
            href="https://magazin.portu.cz/investovani-od-a-do-z/sberatelske-predmety/"
          >
            {{ $t('homepage.blog.more-at-blog') }}
          </Button>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<style lang="scss" scoped>
.container {
  max-width: unset;
  padding: unset;
}

.carousel {
  text-align: left;
  &:focus {
    outline-color: transparent;
  }
}

.carousel__slide {
  display: flex;

  height: inherit;

  padding-right: 0.75rem;
  padding-left: 0.75rem;

  > div {
    height: 100%;
    width: 100%;
  }

  img {
    max-width: 100%;
  }
}

.carousel__pagination {
  flex-wrap: wrap;
  grid-gap: 0.625rem 0;

  padding: 0;

  :deep(.carousel__pagination-button) {
    margin: 0 0.625rem;

    width: 0.875rem;
    height: 0.875rem;

    background-color: var(--brown-light);
    border-radius: 50%;

    &::after {
      content: none;
    }
  }

  :deep(.carousel__pagination-button--active) {
    background-color: var(--red-basic);
  }
}

.col--show-more {
  display: flex;
  justify-content: center;

  .show-all-instruments {
    margin-top: 2.5rem;
  }
}
</style>
